/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

package net.sergeych.kiloparsec.adapter

import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.channels.ReceiveChannel
import kotlinx.coroutines.channels.SendChannel
import kotlinx.coroutines.delay
import net.sergeych.kiloparsec.Transport
import net.sergeych.tools.AtomicCounter

private val counter = AtomicCounter()
open class ProxyDevice(
    private val inputChannel: Channel<UByteArray>,
    private val outputChannel: Channel<UByteArray>,
    private val doClose: (suspend ()->Unit)? = null,
    private val doFlush: (suspend ()->Unit)? = null,
): Transport.Device {

    override val input: ReceiveChannel<UByteArray> = inputChannel
    override val output: SendChannel<UByteArray> = outputChannel

    override suspend fun close() {
        kotlin.runCatching {  doClose?.invoke() }
        runCatching { inputChannel.close() }
        runCatching { outputChannel.close() }
    }

    override suspend fun flush() {
        doFlush?.invoke()
        var cnt = 10
        while(!outputChannel.isEmpty) {
            if (cnt-- < 0) break
            delay(50)
        }
        super.flush()
    }

    private val id = counter.incrementAndGet()

    override fun toString(): String = "PX$id"
}